import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { HeaderServiceProxy } from '@telecom/shared/services/header-service/header-service-proxy';
import { ref, computed } from 'vue';
import { createSharedComposable } from '@vueuse/core';

export const useHeader = createSharedComposable(() => {
    const headerServiceProxy = injectService<HeaderServiceProxy>(HeaderServiceProxy);
    const headerService = headerServiceProxy.headerService;

    // 用户信息相关状态
    const isLoading = ref(true);

    // 直接从 headerService.account 获取用户信息
    const userInfo = computed(() => headerService.account);
    const isLoggedIn = computed(() => !!userInfo.value);

    // 用户显示名称
    const userDisplayName = computed(() => {
        const account = userInfo.value;
        if (!account) return '';
        return account.username || account.email || account.displayName || 'User';
    });

    // 用户邮箱
    const userEmail = computed(() => {
        const account = userInfo.value;
        return account?.email || '';
    });

    // 初始化用户信息
    const initUserInfo = async () => {
        try {
            // 等待 headerService 初始化完成
            await headerService.deferred.promise;

            console.log('HeaderService initialized');
            console.log('User account:', headerService.account);

            // 检查是否有用户数据
            if (headerService.account) {
                console.log('User logged in:', {
                    username: headerService.account.username,
                    email: headerService.account.email,
                    siteRegion: headerService.account.siteRegion,
                });
            } else {
                console.log('No user account found - user not logged in');
            }
        } catch (error) {
            console.warn('Failed to load user info:', error);
        } finally {
            isLoading.value = false;
        }
    };

    // 立即初始化
    initUserInfo();

    // 退出登录
    const logout = () => {
        if (headerService.userCenterService?.logoutHandler) {
            // 使用 headerService 的退出登录处理器
            headerService.userCenterService.logoutHandler(
                () => {
                    // 登出完成回调
                    console.log('User logged out');
                },
                '', // 默认登出重定向URL
            );
        } else {
            // 降级方案：直接重定向到登录页
            window.location.href = '/login';
        }
    };

    return {
        headerService,
        userInfo,
        userDisplayName,
        userEmail,
        isLoggedIn,
        isLoading,
        logout,
    };
});
